import { images } from '../constants'; 

const blogs = [
  {
    id: 1,
    image: images.blog1,
    category: "Vehicle Reviews",
    date: "18 January, 2025",
    admin: "Admin",
    heading: "Latest Car Models You Need to Know About",
    content: "Stay up-to-date with the latest car models and trends. Whether you're looking for performance, design, or technology, these new releases offer something for everyone.",
    important: {
        content: "Explore expert insights on the latest cars to hit the market. From advanced features to sleek designs, these cars will make you rethink what you know about driving.",
        intro: "Automotive Expert"
    },
    paragraph: {
        para1: "The new models for 2025 come with cutting-edge technology, providing more safety features, better fuel efficiency, and enhanced comfort for every journey.",
        para2: "Whether you’re into electric vehicles or looking for a powerful sports car, this year’s lineup is filled with options to suit every taste.",
        para3: "Keep an eye on eco-friendly options as manufacturers push the envelope on electric and hybrid vehicles.",
        para4: "Don’t forget to check out the latest upgrades in interior design, infotainment systems, and autonomous driving capabilities."
    },
    gallery: [   
      images.blog1Gallery1,
      images.blog1Gallery2,
    ],
    tags: ["Cars", "Models", "Buying"],
    comments: [
      { 
          id: 1,
          image: images.blog3Comment1,
          name: "Olivia Adams",
          date: "19 January, 2025",
          content: "I’ve been waiting for the latest electric vehicle releases, and this year looks promising! Can't wait to test them out.",
          replies: [
              {
                  id: 1,
                  image: images.blog3Comment2,
                  name: "Michael Thompson",
                  date: "20 January, 2025",
                  content: "Same here! The new hybrid models are going to change the game."
              }
          ]
      },
      {
          id: 2,
          image: images.blog3Comment3,
          name: "Emma Williams",
          date: "21 January, 2025",
          content: "Great roundup of the newest cars. I’m definitely eyeing the new sports cars for 2025!"
      }
    ]
  },
  {
    id: 2,
    image: images.blog2,
    category: "Car Maintenance",
    date: "09 January, 2025",
    admin: "Admin",
    heading: "The Ultimate Guide to Changing Car’s Oil",
    content: "Learn how to properly change your car’s oil with this comprehensive guide. Keep your engine running smoothly by following essential oil change steps.",
    important: {
      content: "Expert advice on oil changes to help maintain your car’s engine health. Discover the right type of oil, tools, and techniques for a successful oil change.",
      intro: "Automotive Mechanic"
    },
    paragraph: {
      para1: "Changing your car's oil regularly is crucial for engine performance. Fresh oil reduces friction, prevents overheating, and helps maintain smooth operation.",
      para2: "Make sure to use the recommended oil type for your car model. Always check the owner’s manual to determine the right oil viscosity and quality.",
      para3: "Tools needed for an oil change include a wrench, oil filter, drain pan, and funnel. Ensure you have all the necessary tools before starting.",
      para4: "Dispose of the old oil properly. Most auto shops offer oil recycling services, so make sure to take your used oil to an authorized location."
    },
    gallery: [   
      images.blog2Gallery1,
      images.blog2Gallery2,
    ],
    tags: ["Oil", "Cars", "Driving"],
    comments: [
      {
        id: 1,
        image: images.blog2Comment1,
        name: "Olivia Adams",
        date: "10 January, 2025",
        content: "Thanks for this guide! I’ve been wanting to change my car’s oil myself but wasn't sure where to start.",
        replies: [
          {
            id: 1,
            image: images.blog2Comment2,
            name: "Michael Thompson",
            date: "11 January, 2025",
            content: "Glad I could help! It’s not too difficult once you have the right tools and instructions."
          }
        ]
      },
      {
        id: 2,
        image: images.blog2Comment3,
        name: "Emma Williams",
        date: "12 January, 2025",
        content: "This is very useful! I'll be doing my next oil change with confidence."
      }
    ]
  },
  {
    id: 3,
    image: images.blog3,
    category: "Car Buying",
    date: "30 December, 2024",
    admin: "Admin",
    heading: "A Complete Guide to Buying a New Car",
    content: "Buying a new car can be overwhelming. This guide covers everything you need to know, from research to finalizing the deal, to ensure you make the best purchase.",
    important: {
      content: "Explore expert tips on the car-buying process. Learn how to choose the right model, negotiate pricing, and secure the best financing options.",
      intro: "Car Buying Expert"
    },
    paragraph: {
      para1: "Start by determining your budget. Factor in not just the car’s price but also insurance, taxes, registration, and future maintenance costs.",
      para2: "Do thorough research on different makes and models. Consider factors such as fuel efficiency, safety ratings, and reliability before narrowing down your choices.",
      para3: "Once you’ve chosen your car, it's time to negotiate. Be prepared to walk away if the dealer isn’t offering a fair price.",
      para4: "Review financing options carefully. Look at both dealership financing and loans from your bank to ensure you’re getting the best rate."
    },
    gallery: [   
      images.blog3Gallery1,
      images.blog3Gallery2,
    ],
    tags: ["Buying", "Cars", "Models"],
    comments: [
      {
        id: 1,
        image: images.blog3Comment1,
        name: "Olivia Adams",
        date: "31 December, 2024",
        content: "This guide was so helpful! I was feeling overwhelmed with all the options, but now I have a clear plan.",
        replies: [
          {
            id: 1,
            image: images.blog3Comment2,
            name: "Michael Thompson",
            date: "1 January, 2025",
            content: "I feel the same! Knowing what to look for when negotiating is a game changer."
          }
        ]
      },
      {
        id: 2,
        image: images.blog3Comment3,
        name: "Emma Williams",
        date: "2 January, 2025",
        content: "I’ve been thinking about buying a new car this year, and this guide has made the process so much clearer!"
      }
    ]
  },
  {
    id: 4,
    image: images.blog4,
    category: "Car Accessories",
    date: "21 December, 2024",
    admin: "Admin",
    heading: "The Right Roof Rack for Your Car",
    content: "Choosing the right roof rack for your car can make transporting gear easy and safe. This guide will help you pick the best roof rack based on your vehicle and needs.",
    important: {
      content: "Learn the essentials of selecting the right roof rack for your car. From weight capacity to installation ease, get expert advice on the best options for your lifestyle.",
      intro: "Car Accessory Expert"
    },
    paragraph: {
      para1: "First, consider the type of gear you'll be carrying. Roof racks are designed for different uses, including bikes, kayaks, skis, and cargo boxes.",
      para2: "Ensure the roof rack is compatible with your car’s make and model. Some cars may require specific mounting systems, such as raised rails or a bare roof.",
      para3: "Check the weight capacity of the roof rack and ensure it can support the items you're planning to carry. Don’t exceed the recommended weight limits for safety.",
      para4: "Ease of installation is another key factor. Some roof racks are tool-free, while others may require a little more effort. Choose one that suits your comfort level."
    },
    gallery: [   
      images.blog4Gallery1,
      images.blog4Gallery2,
    ],
    tags: ["Rack", "Cars", "Buying"],
    comments: [
      {
        id: 1,
        image: images.blog4Comment1,
        name: "Olivia Adams",
        date: "22 December, 2024",
        content: "I didn’t realize there were so many options for roof racks! This guide is super helpful for narrowing it down.",
        replies: [
          {
            id: 1,
            image: images.blog4Comment2,
            name: "Michael Thompson",
            date: "23 December, 2024",
            content: "Definitely! I’ve been looking for one for my car, and this makes the decision much easier."
          }
        ]
      },
      {
        id: 2,
        image: images.blog4Comment3,
        name: "Emma Williams",
        date: "24 December, 2024",
        content: "I’m planning a road trip, and a roof rack is a must. This post answered all my questions!"
      }
    ]
  },
  {
    id: 5,
    image: images.blog5,
    category: "Security Tips",
    date: "12 December, 2024",
    admin: "Admin",
    heading: "How to Stay Safe on Icy Roads",
    content: "Icy roads can be treacherous, but with the right precautions, you can stay safe. Learn essential safety tips for driving on icy and slippery conditions this winter.",
    important: {
      content: "Discover expert advice on how to navigate icy roads. From winter tires to safe driving practices, stay prepared and reduce your risk of accidents.",
      intro: "Winter Safety Expert"
    },
    paragraph: {
      para1: "First, equip your vehicle with winter tires. These tires provide better traction and help you maintain control on slippery surfaces.",
      para2: "Slow down! Even if you're familiar with the road, ice can make it unpredictable. Reducing your speed will help you react quickly if conditions change.",
      para3: "Keep a safe distance from other vehicles. Allow extra space between you and the car in front, as stopping distances on icy roads are much longer.",
      para4: "If you start to skid, remain calm. Avoid slamming on the brakes and instead gently steer in the direction you want the front of your car to go."
    },
    gallery: [   
      images.blog5Gallery1,
      images.blog5Gallery2,
    ],
    tags: ["Safety", "Driving", "Cars"],
    comments: [
      {
        id: 1,
        image: images.blog5Comment1,
        name: "Olivia Adams",
        date: "13 December, 2024",
        content: "These tips are exactly what I needed! I always get nervous driving on icy roads, but now I feel more confident.",
        replies: [
          {
            id: 1,
            image: images.blog5Comment2,
            name: "Michael Thompson",
            date: "14 December, 2024",
            content: "Same here! I didn’t realize how important it is to have winter tires. I’ll be getting a set this weekend."
          }
        ]
      },
      {
        id: 2,
        image: images.blog5Comment3,
        name: "Emma Williams",
        date: "15 December, 2024",
        content: "Great advice! I never thought about how much longer it takes to stop on ice. I’ll make sure to leave extra space."
      }
    ]
  },
  {
    id: 6,
    image: images.blog6,
    category: "Vehicle Reviews",
    date: "05 December, 2024",
    admin: "Admin",
    heading: "Why Electric Vehicles Are the Future",
    content: "Electric vehicles (EVs) are not just a trend—they’re the future of driving. Learn why more drivers are making the switch to EVs and how they’re shaping the road ahead.",
    important: {
      content: "Discover the benefits of electric vehicles, from reducing your carbon footprint to saving on fuel costs. The future of driving is electric, and now is the perfect time to make the switch.",
      intro: "EV Advocate"
    },
    paragraph: {
      para1: "Electric vehicles offer a greener alternative to traditional gasoline cars. By reducing harmful emissions, they play a key role in combating climate change.",
      para2: "One of the major advantages of EVs is their lower operating costs. Electricity is cheaper than gasoline, and with fewer moving parts, EVs require less maintenance.",
      para3: "With an increasing number of charging stations and advancements in battery technology, range anxiety is becoming a thing of the past. More drivers are embracing EVs as their primary vehicles.",
      para4: "Incentives like government rebates and tax credits are making EVs more affordable. As technology advances, the price of EVs continues to fall, making them more accessible to a wider audience."
    },
    gallery: [   
      images.blog6Gallery1,
      images.blog6Gallery2,
    ],
    tags: ["Electric", "Cars", "Models"],
    comments: [
      {
        id: 1,
        image: images.blog6Comment1,
        name: "Olivia Adams",
        date: "06 December, 2024",
        content: "I’ve been thinking about getting an EV for a while now. This post gave me the final push to start researching models!",
        replies: [
          {
            id: 1,
            image: images.blog6Comment2,
            name: "Michael Thompson",
            date: "07 December, 2024",
            content: "Great decision! I switched to an EV last year, and I love it. The savings on gas alone make it worth it."
          }
        ]
      },
      {
        id: 2,
        image: images.blog6Comment3,
        name: "Emma Williams",
        date: "08 December, 2024",
        content: "I never realized how much cheaper it is to maintain an EV compared to a traditional car. I’m definitely considering one for my next purchase."
      }
    ]
  },
  {
    id: 7,
    image: images.blog7,
    category: "Car Maintenance",
    date: "01 December, 2024",
    admin: "Admin",
    heading: "Mastering the Art of Car Oil Changes",
    content: "Electric vehicles (EVs) are not just a trend—they’re the future of driving. Learn why more drivers are making the switch to EVs and how they’re shaping the road ahead.",
    important: {
      content: "Discover the benefits of electric vehicles, from reducing your carbon footprint to saving on fuel costs. The future of driving is electric, and now is the perfect time to make the switch.",
      intro: "EV Advocate"
    },
    paragraph: {
      para1: "Electric vehicles offer a greener alternative to traditional gasoline cars. By reducing harmful emissions, they play a key role in combating climate change.",
      para2: "One of the major advantages of EVs is their lower operating costs. Electricity is cheaper than gasoline, and with fewer moving parts, EVs require less maintenance.",
      para3: "With an increasing number of charging stations and advancements in battery technology, range anxiety is becoming a thing of the past. More drivers are embracing EVs as their primary vehicles.",
      para4: "Incentives like government rebates and tax credits are making EVs more affordable. As technology advances, the price of EVs continues to fall, making them more accessible to a wider audience."
    },
    gallery: [   
      images.blog7Gallery1,
      images.blog7Gallery2,
    ],
    tags: ["Oil", "Cars", "Safety"],
    comments: [
      {
        id: 1,
        image: images.blog7Comment1,
        name: "Olivia Adams",
        date: "06 December, 2024",
        content: "I’ve been thinking about getting an EV for a while now. This post gave me the final push to start researching models!",
        replies: [
          {
            id: 1,
            image: images.blog7Comment2,
            name: "Michael Thompson",
            date: "07 December, 2024",
            content: "Great decision! I switched to an EV last year, and I love it. The savings on gas alone make it worth it."
          }
        ]
      },
      {
        id: 2,
        image: images.blog7Comment3,
        name: "Emma Williams",
        date: "08 December, 2024",
        content: "I never realized how much cheaper it is to maintain an EV compared to a traditional car. I’m definitely considering one for my next purchase."
      }
    ]
  },
  {
    id: 8,
    image: images.blog8,
    category: "Car Buying",
    date: "25 Novemeber, 2024",
    admin: "Admin",
    heading: "Complete Roadmap to Purchasing a New Car",
    content: "Buying a new car can be overwhelming. This guide covers everything you need to know, from research to finalizing the deal, to ensure you make the best purchase.",
    important: {
      content: "Explore expert tips on the car-buying process. Learn how to choose the right model, negotiate pricing, and secure the best financing options.",
      intro: "Car Buying Expert"
    },
    paragraph: {
      para1: "Start by determining your budget. Factor in not just the car’s price but also insurance, taxes, registration, and future maintenance costs.",
      para2: "Do thorough research on different makes and models. Consider factors such as fuel efficiency, safety ratings, and reliability before narrowing down your choices.",
      para3: "Once you’ve chosen your car, it's time to negotiate. Be prepared to walk away if the dealer isn’t offering a fair price.",
      para4: "Review financing options carefully. Look at both dealership financing and loans from your bank to ensure you’re getting the best rate."
    },
    gallery: [   
      images.blog8Gallery1,
      images.blog8Gallery2,
    ],
    tags: ["Buying", "Cars", "Models"],
    comments: [
      {
        id: 1,
        image: images.blog8Comment1,
        name: "Olivia Adams",
        date: "31 December, 2024",
        content: "This guide was so helpful! I was feeling overwhelmed with all the options, but now I have a clear plan.",
        replies: [
          {
            id: 1,
            image: images.blog8Comment2,
            name: "Michael Thompson",
            date: "1 January, 2025",
            content: "I feel the same! Knowing what to look for when negotiating is a game changer."
          }
        ]
      },
      {
        id: 2,
        image: images.blog8Comment3,
        name: "Emma Williams",
        date: "2 January, 2025",
        content: "I’ve been thinking about buying a new car this year, and this guide has made the process so much clearer!"
      }
    ]
  },
  {
    id: 9,
    image: images.blog9,
    category: "Car Accessories",
    date: "11 November, 2024",
    admin: "Admin",
    heading: "Perfect Roof Rack for Your Vehicle",
    content: "Choosing the right roof rack for your car can make transporting gear easy and safe. This guide will help you pick the best roof rack based on your vehicle and needs.",
    important: {
      content: "Learn the essentials of selecting the right roof rack for your car. From weight capacity to installation ease, get expert advice on the best options for your lifestyle.",
      intro: "Car Accessory Expert"
    },
    paragraph: {
      para1: "First, consider the type of gear you'll be carrying. Roof racks are designed for different uses, including bikes, kayaks, skis, and cargo boxes.",
      para2: "Ensure the roof rack is compatible with your car’s make and model. Some cars may require specific mounting systems, such as raised rails or a bare roof.",
      para3: "Check the weight capacity of the roof rack and ensure it can support the items you're planning to carry. Don’t exceed the recommended weight limits for safety.",
      para4: "Ease of installation is another key factor. Some roof racks are tool-free, while others may require a little more effort. Choose one that suits your comfort level."
    },
    gallery: [   
      images.blog9Gallery1,
      images.blog9Gallery2,
    ],
    tags: ["Rack", "Cars", "Buying"],
    comments: [
      {
        id: 1,
        image: images.blog9Comment1,
        name: "Olivia Adams",
        date: "22 December, 2024",
        content: "I didn’t realize there were so many options for roof racks! This guide is super helpful for narrowing it down.",
        replies: [
          {
            id: 1,
            image: images.blog9Comment2,
            name: "Michael Thompson",
            date: "23 December, 2024",
            content: "Definitely! I’ve been looking for one for my car, and this makes the decision much easier."
          }
        ]
      },
      {
        id: 2,
        image: images.blog9Comment3,
        name: "Emma Williams",
        date: "24 December, 2024",
        content: "I’m planning a road trip, and a roof rack is a must. This post answered all my questions!"
      }
    ]
  },
  {
    id: 10,
    image: images.blog10,
    category: "Security Tips",
    date: "02 Novemebr, 2024",
    admin: "Admin",
    heading: "Tips for Driving Safely on Icy Roads",
    content: "Icy roads can be treacherous, but with the right precautions, you can stay safe. Learn essential safety tips for driving on icy and slippery conditions this winter.",
    important: {
      content: "Discover expert advice on how to navigate icy roads. From winter tires to safe driving practices, stay prepared and reduce your risk of accidents.",
      intro: "Winter Safety Expert"
    },
    paragraph: {
      para1: "First, equip your vehicle with winter tires. These tires provide better traction and help you maintain control on slippery surfaces.",
      para2: "Slow down! Even if you're familiar with the road, ice can make it unpredictable. Reducing your speed will help you react quickly if conditions change.",
      para3: "Keep a safe distance from other vehicles. Allow extra space between you and the car in front, as stopping distances on icy roads are much longer.",
      para4: "If you start to skid, remain calm. Avoid slamming on the brakes and instead gently steer in the direction you want the front of your car to go."
    },
    gallery: [   
      images.blog10Gallery1,
      images.blog10Gallery2,
    ],
    tags: ["Driving", "Safety", "Cars"],
    comments: [
      {
        id: 1,
        image: images.blog10Comment1,
        name: "Olivia Adams",
        date: "13 December, 2024",
        content: "These tips are exactly what I needed! I always get nervous driving on icy roads, but now I feel more confident.",
        replies: [
          {
            id: 1,
            image: images.blog10Comment2,
            name: "Michael Thompson",
            date: "14 December, 2024",
            content: "Same here! I didn’t realize how important it is to have winter tires. I’ll be getting a set this weekend."
          }
        ]
      },
      {
        id: 2,
        image: images.blog10Comment3,
        name: "Emma Williams",
        date: "15 December, 2024",
        content: "Great advice! I never thought about how much longer it takes to stop on ice. I’ll make sure to leave extra space."
      }
    ]
  },
];

export default blogs;